<template>
    <div style="border: 1px solid #ccc;background-color: #fff;">
        <div class="d-flex justify-content-between align-items-center px-5 py-5"
            style="border-bottom: 1px solid #ccc;">
            <h1 style="font-size: 16px;margin-bottom: 0px;">Báo cáo chỉ số gia sư</h1>
            <div class="button-list">
                <el-button v-if="activeTab === 'video'" type="primary" size="small" icon="el-icon-download"
                    @click="handleExport">
                    Export
                </el-button>
            </div>
        </div>
        <div>
            <ul class="nav nav-tabs nav-bold nav-tabs-line px-5 pt-3" style="border-bottom: 1px solid #ccc;">
                <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'direct' }" href="javascript:;"
                        @click="activeTab = 'direct'">
                        Báo cáo dạy trực tiếp
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'video' }" href="javascript:;"
                        @click="activeTab = 'video'">
                        Báo cáo học bù video
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div v-if="activeTab === 'direct'">
                    <TutorDirectReport />
                </div>
                <div v-if="activeTab === 'video'">
                    <TutorVideoReport ref="videoReport" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TutorDirectReport from './TutorDirectReport.vue';
import TutorVideoReport from './TutorVideoReport.vue';
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";

const TAB_LABELS = {
    direct: 'Báo cáo dạy trực tiếp',
    video: 'Báo cáo học bù video',
};

export default {
    name: "TutorReport",
    components: {
        TutorDirectReport,
        TutorVideoReport,
    },
    data() {
        return {
            activeTab: 'direct',
        }
    },
    watch: {
        activeTab(newVal) {
            this.updateBreadcrumb(newVal);
            if (this.$route.query.tab !== newVal) {
                this.$router.replace({
                    name: "report-for-tutor",
                    query: {
                        ...this.$route.query,
                        tab: newVal
                    }
                }).catch(() => {})
            }
        }
    },
    methods: {
        handleExport() {
            if (this.$refs.videoReport) {
                this.$refs.videoReport.exportReport()
            }
        },
        updateBreadcrumb(tab) {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Báo cáo gia sư", route: 'report-for-tutor'},
                {title: TAB_LABELS[tab] || TAB_LABELS.direct},
            ]);
        }
    },
    mounted() {
        const tab = this.$route.query.tab
        if (tab === 'video') {
            this.activeTab = 'video'
        }
        this.updateBreadcrumb(this.activeTab);
    }
}
</script>
